var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modify-supplement-edit" },
    [
      _c("el-card", { attrs: { "body-style": _vm.cardBodyStyle } }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            staticStyle: { padding: "8px 16px" },
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.isReadOnly ? "查看改补详情" : "编辑改补信息")),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { float: "right", padding: "3px 0" },
                attrs: { type: "text" },
                on: { click: _vm.goBack },
              },
              [_vm._v("返回")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
          },
          [
            _c("div", { staticClass: "detail-section" }, [
              _c("div", { staticClass: "detail-section-title" }, [
                _vm._v("原单信息"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    gap: "12px 0",
                    padding: "4px 0",
                    "font-size": "13px",
                  },
                },
                [
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("合同号："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.contractNo || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("原合同号："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.originalContractNo || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("客户姓名："),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.contract.custName || "-"))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("客户电话："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.custMobile || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("客户地址："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.custAddress || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("省市区："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.contract.province || "") +
                            (_vm.contract.city || "") +
                            (_vm.contract.district || "") || "-"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("下单人："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.parseNickName(_vm.contract.orderClerkNickName) ||
                            "-"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("设计师："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.parseNickName(_vm.contract.designerNickName) ||
                            "-"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("导购："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.parseNickName(_vm.contract.guideNickName) || "-"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("经销商："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.dealerShopName || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("门店："),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.contract.storeName || "-"))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("渠道类型："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.contract.msgFrom ||
                            _vm.contract.channelType ||
                            "-"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("安装主管："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.installMamager || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("安装组长："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.installGroup || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("安装技术员："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.installPerson || "-")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("完工日期："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.contract.installFinishTime ||
                            _vm.contract.actualFinishingDate ||
                            "-"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _c("span", { staticStyle: { color: "#606266" } }, [
                      _vm._v("创建时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.contract.createdatetime || "-")),
                    ]),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-section" }, [
              _c("div", { staticClass: "detail-section-title" }, [
                _vm._v("改补信息"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    gap: "12px 0",
                    padding: "6px 0",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("改补类型："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(_vm._s(_vm.getAmendType)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("联系人："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(_vm._s(_vm.afterInfo.contactPerson || "-")),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("联系电话："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(_vm._s(_vm.afterInfo.contactNumber || "-")),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("联系地址："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(_vm._s(_vm.afterInfo.contactAddress || "-")),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("问题原因："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(_vm._s(_vm.afterInfo.problemCause || "-")),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("问题现状："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(_vm._s(_vm.afterInfo.problemNow || "-")),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("备注："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(_vm._s(_vm.afterInfo.problemDescription || "-")),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("要求到货日期："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#303133" } }, [
                        _vm._v(
                          _vm._s(_vm.afterInfo.requiredDeliveryDate || "-")
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    gap: "12px 0",
                    padding: "6px 0",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "33.33%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("问题图片："),
                      ]),
                      _vm._v(" "),
                      _vm.afterInfo.problemImg
                        ? _c(
                            "span",
                            _vm._l(
                              _vm.parseFiles(_vm.afterInfo.problemImg),
                              function (item, idx) {
                                return _c(
                                  "span",
                                  {
                                    key: idx,
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-right": "8px",
                                      "margin-bottom": "8px",
                                    },
                                  },
                                  [
                                    _c("el-image", {
                                      staticStyle: {
                                        width: "80px",
                                        height: "80px",
                                        "border-radius": "4px",
                                      },
                                      attrs: {
                                        src:
                                          item.url ||
                                          _vm.$store.getters.imgPreviewPrefix +
                                            item.realName,
                                        fit: "cover",
                                        "preview-src-list": _vm.getPreviewList(
                                          _vm.afterInfo.problemImg
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _c("span", { staticStyle: { color: "#909399" } }, [
                            _vm._v("暂无图片"),
                          ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "66.66%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("附件："),
                      ]),
                      _vm._v(" "),
                      _vm.parseFiles(_vm.afterInfo.file).length > 0
                        ? _c(
                            "span",
                            _vm._l(
                              _vm.parseFiles(_vm.afterInfo.file),
                              function (item, idx) {
                                return _c(
                                  "span",
                                  {
                                    key: idx,
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-right": "16px",
                                      "margin-bottom": "8px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          type: "primary",
                                          href: _vm.getFileUrl(item),
                                          download:
                                            item.localName || item.realName,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-paperclip",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.localName ||
                                                item.realName ||
                                                "附件" + (idx + 1)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _c("span", { staticStyle: { color: "#909399" } }, [
                            _vm._v("暂无附件"),
                          ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    gap: "12px 0",
                    padding: "6px 0",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "100%", padding: "4px 8px" } },
                    [
                      _c("span", { staticStyle: { color: "#606266" } }, [
                        _vm._v("物料附件："),
                      ]),
                      _vm._v(" "),
                      _vm.parseFiles(_vm.afterInfo.otherFile).length > 0
                        ? _c(
                            "span",
                            _vm._l(
                              _vm.parseFiles(_vm.afterInfo.otherFile),
                              function (item, idx) {
                                return _c(
                                  "span",
                                  {
                                    key: idx,
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-right": "16px",
                                      "margin-bottom": "8px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          type: "primary",
                                          href: _vm.getFileUrl(item),
                                          download:
                                            item.localName || item.realName,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-paperclip",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.localName ||
                                                item.realName ||
                                                "附件" + (idx + 1)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _c("span", { staticStyle: { color: "#909399" } }, [
                            _vm._v("暂无附件"),
                          ]),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.checkPer(["admin", "modifySupplement:audit"])
              ? _c(
                  "div",
                  { staticClass: "detail-section" },
                  [
                    _c("div", { staticClass: "detail-section-title" }, [
                      _vm._v("初判信息"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { size: "small" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "改补类型",
                                      "label-width": "80px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "-",
                                          clearable: "",
                                          disabled: !_vm.canEditJudgment,
                                        },
                                        model: {
                                          value: _vm.afterInfo.amendmentType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.afterInfo,
                                              "amendmentType",
                                              $$v
                                            )
                                          },
                                          expression: "afterInfo.amendmentType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "遗留单",
                                            value: "遗留单",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: {
                                            label: "售后单",
                                            value: "售后单",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "处理人",
                                      "label-width": "80px",
                                    },
                                  },
                                  [
                                    _vm.canEditJudgment
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              gap: "8px",
                                            },
                                          },
                                          [
                                            _vm.afterInfo.assignNickName
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "2px",
                                                    },
                                                    attrs: { type: "success" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.afterInfo
                                                          .assignNickName
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#909399",
                                                      "font-size": "13px",
                                                    },
                                                  },
                                                  [_vm._v("未选择")]
                                                ),
                                            _vm._v(" "),
                                            _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-plus",
                                                size: "mini",
                                              },
                                              on: { click: _vm.openUserSelect },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.afterInfo.assignNickName ||
                                                "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "要求入库时间",
                                      "label-width": "80px",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        placeholder: "-",
                                        "value-format": "yyyy-MM-dd HH:00:00",
                                        "picker-options": {
                                          disabledMinutes: function () {
                                            return Array.from(
                                              { length: 60 },
                                              function (_, i) {
                                                return i
                                              }
                                            ).filter(function (m) {
                                              return m !== 0
                                            })
                                          },
                                          disabledSeconds: function () {
                                            return Array.from(
                                              { length: 60 },
                                              function (_, i) {
                                                return i
                                              }
                                            ).filter(function (s) {
                                              return s !== 0
                                            })
                                          },
                                        },
                                        disabled: !_vm.canEditJudgment,
                                      },
                                      model: {
                                        value:
                                          _vm.afterInfo.requiredInboundTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.afterInfo,
                                            "requiredInboundTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "afterInfo.requiredInboundTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "初判备注",
                                      "label-width": "80px",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: "2",
                                        placeholder: "-",
                                        disabled: !_vm.canEditJudgment,
                                      },
                                      model: {
                                        value: _vm.afterInfo.auditRemark,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.afterInfo,
                                            "auditRemark",
                                            $$v
                                          )
                                        },
                                        expression: "afterInfo.auditRemark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "跟进备注",
                                      "label-width": "80px",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: "3",
                                        placeholder: "请输入跟进备注",
                                        maxlength: "2000",
                                        "show-word-limit": "",
                                        disabled: _vm.isReadOnly,
                                      },
                                      model: {
                                        value: _vm.afterInfo.serviceRemark,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.afterInfo,
                                            "serviceRemark",
                                            $$v
                                          )
                                        },
                                        expression: "afterInfo.serviceRemark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "跟进附件",
                                      "label-width": "80px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          action: _vm.filesUploadApi,
                                          headers: _vm.headers,
                                          "on-success": function (
                                            res,
                                            file,
                                            fileList
                                          ) {
                                            return _vm.handleUploadSuccess(
                                              "serviceFile",
                                              res,
                                              file,
                                              fileList
                                            )
                                          },
                                          "before-upload":
                                            _vm.handleBeforeUpload,
                                          multiple: "",
                                          "show-file-list": false,
                                          disabled: _vm.isReadOnly,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "primary",
                                              disabled: _vm.isReadOnly,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-upload",
                                            }),
                                            _vm._v(" 上传跟进附件"),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.serviceFileList.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "8px",
                                              width: "100%",
                                            },
                                          },
                                          _vm._l(
                                            _vm.serviceFileList,
                                            function (item, idx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: idx,
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                    width: "100%",
                                                    padding: "3px 0",
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm.isImageFile(item)
                                                    ? [
                                                        _c("el-image", {
                                                          staticStyle: {
                                                            width: "36px",
                                                            height: "36px",
                                                            "border-radius":
                                                              "4px",
                                                            "margin-right":
                                                              "8px",
                                                          },
                                                          attrs: {
                                                            src: _vm.getFileUrl(
                                                              item
                                                            ),
                                                            fit: "cover",
                                                            "preview-src-list":
                                                              _vm.serviceFileImageList,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-link",
                                                          {
                                                            staticStyle: {
                                                              flex: "1",
                                                              overflow:
                                                                "hidden",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              "white-space":
                                                                "nowrap",
                                                            },
                                                            attrs: {
                                                              type: "primary",
                                                              href: _vm.getFileUrl(
                                                                item
                                                              ),
                                                              download:
                                                                item.localName ||
                                                                item.realName,
                                                              target: "_blank",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  item.localName ||
                                                                    item.name ||
                                                                    item.realName ||
                                                                    "附件" +
                                                                      (idx + 1)
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _c(
                                                        "el-link",
                                                        {
                                                          staticStyle: {
                                                            flex: "1",
                                                            overflow: "hidden",
                                                            "text-overflow":
                                                              "ellipsis",
                                                            "white-space":
                                                              "nowrap",
                                                          },
                                                          attrs: {
                                                            type: "primary",
                                                            href: _vm.getFileUrl(
                                                              item
                                                            ),
                                                            download:
                                                              item.localName ||
                                                              item.realName,
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-paperclip",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.localName ||
                                                                  item.name ||
                                                                  item.realName ||
                                                                  "附件" +
                                                                    (idx + 1)
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  !_vm.isReadOnly
                                                    ? _c("el-button", {
                                                        staticStyle: {
                                                          "margin-left": "8px",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          size: "mini",
                                                          icon: "el-icon-delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleRemoveServiceFile(
                                                              idx
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#909399",
                                              "font-size": "13px",
                                            },
                                          },
                                          [_vm._v("暂无附件")]
                                        ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isReadOnly
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "80px" } },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                              icon: "el-icon-check",
                                              loading: _vm.serviceSaveLoading,
                                            },
                                            on: {
                                              click: _vm.handleSaveService,
                                            },
                                          },
                                          [_vm._v("保存信息")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#909399",
                                              "font-size": "12px",
                                              "margin-left": "8px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "保存判责与跟进信息；提交后仍可编辑保存"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "detail-section" },
              [
                _c("div", { staticClass: "detail-section-title" }, [
                  _vm._v("物料"),
                ]),
                _vm._v(" "),
                _c(
                  "el-tabs",
                  {
                    model: {
                      value: _vm.materialTab,
                      callback: function ($$v) {
                        _vm.materialTab = $$v
                      },
                      expression: "materialTab",
                    },
                  },
                  [
                    _vm.getAmendType === "改单"
                      ? _c(
                          "el-tab-pane",
                          { attrs: { label: "酷家乐物料", name: "kujiale" } },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.batchKujialeLoading,
                                    expression: "batchKujialeLoading",
                                  },
                                ],
                                attrs: {
                                  "element-loading-text": "正在保存...",
                                  "element-loading-spinner": "el-icon-loading",
                                  "element-loading-background":
                                    "rgba(255, 255, 255, 0.7)",
                                },
                              },
                              [
                                _vm.kujialeMaterialList.length === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                              icon: "el-icon-refresh",
                                              loading: _vm.syncBomLoading,
                                              disabled: !_vm.canEditJudgment,
                                            },
                                            on: { click: _vm.handleSyncBom },
                                          },
                                          [_vm._v("同步酷家乐物料")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.kujialeMaterialList.length > 0
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                              padding: "8px",
                                              background: "#fafafa",
                                              "border-radius": "4px",
                                              display: "flex",
                                              "align-items": "center",
                                              gap: "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#606266",
                                                },
                                              },
                                              [_vm._v("批量修改：")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "110px" },
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "问题类型",
                                                  clearable: "",
                                                  disabled:
                                                    !_vm.canEditJudgment,
                                                },
                                                model: {
                                                  value:
                                                    _vm.batchKujialeForm
                                                      .problemType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.batchKujialeForm,
                                                      "problemType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batchKujialeForm.problemType",
                                                },
                                              },
                                              _vm._l(
                                                _vm.dict.after_problem_type,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.value,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isShowDutyPerson(
                                              _vm.batchKujialeForm.problemType
                                            )
                                              ? _c("treeselect", {
                                                  staticClass:
                                                    "duty-dept-select",
                                                  staticStyle: {
                                                    width: "200px",
                                                  },
                                                  attrs: {
                                                    value: _vm.deptSelectValue(
                                                      _vm.batchKujialeForm
                                                    ),
                                                    options: _vm.dutyDeptTree,
                                                    clearable: true,
                                                    disabled:
                                                      !_vm.canEditJudgment,
                                                    "append-to-body": true,
                                                    "max-height": 450,
                                                    "z-index": 3000,
                                                    placeholder: "责任部门",
                                                  },
                                                  on: {
                                                    input: function (id) {
                                                      return _vm.setBatchDutyDept(
                                                        "batchKujialeForm",
                                                        id
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isShowDutyPerson(
                                              _vm.batchKujialeForm.problemType
                                            )
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "140px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      placeholder: "责任人",
                                                      filterable: "",
                                                      clearable: "",
                                                      loading:
                                                        !!_vm
                                                          .dutyDeptUsersLoading[
                                                          _vm.batchKujialeForm
                                                            .dutyDeptId
                                                        ],
                                                      disabled:
                                                        !_vm.canEditJudgment,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleBatchDutyPersonChange(
                                                          "batchKujialeForm"
                                                        )
                                                      },
                                                      "visible-change":
                                                        function (visible) {
                                                          return (
                                                            visible &&
                                                            _vm.loadDeptUsers(
                                                              _vm
                                                                .batchKujialeForm
                                                                .dutyDeptId
                                                            )
                                                          )
                                                        },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.batchKujialeForm
                                                          .dutyPerson,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.batchKujialeForm,
                                                          "dutyPerson",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "batchKujialeForm.dutyPerson",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.deptUserOptions(
                                                      _vm.batchKujialeForm
                                                        .dutyDeptId
                                                    ),
                                                    function (u) {
                                                      return _c("el-option", {
                                                        key: u.value,
                                                        attrs: {
                                                          label: u.label,
                                                          value: u.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isShowDutyPerson(
                                              _vm.batchKujialeForm.problemType
                                            )
                                              ? _c("treeselect", {
                                                  staticClass:
                                                    "duty-dept-select",
                                                  staticStyle: {
                                                    width: "200px",
                                                  },
                                                  attrs: {
                                                    value:
                                                      _vm.finalDeptSelectValue(
                                                        _vm.batchKujialeForm
                                                      ),
                                                    options: _vm.dutyDeptTree,
                                                    clearable: true,
                                                    disabled: _vm.isReadOnly,
                                                    "append-to-body": true,
                                                    "max-height": 450,
                                                    "z-index": 3000,
                                                    placeholder: "终判部门",
                                                  },
                                                  on: {
                                                    input: function (id) {
                                                      return _vm.setBatchFinalDept(
                                                        "batchKujialeForm",
                                                        id
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isShowDutyPerson(
                                              _vm.batchKujialeForm.problemType
                                            )
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "140px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      placeholder: "终判责任人",
                                                      filterable: "",
                                                      clearable: "",
                                                      loading:
                                                        !!_vm
                                                          .dutyDeptUsersLoading[
                                                          _vm.batchKujialeForm
                                                            .finalDeptId
                                                        ],
                                                      disabled: _vm.isReadOnly,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleBatchFinalPersonChange(
                                                          "batchKujialeForm"
                                                        )
                                                      },
                                                      "visible-change":
                                                        function (visible) {
                                                          return (
                                                            visible &&
                                                            _vm.loadDeptUsers(
                                                              _vm
                                                                .batchKujialeForm
                                                                .finalDeptId
                                                            )
                                                          )
                                                        },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.batchKujialeForm
                                                          .finalPerson,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.batchKujialeForm,
                                                          "finalPerson",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "batchKujialeForm.finalPerson",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.deptUserOptions(
                                                      _vm.batchKujialeForm
                                                        .finalDeptId
                                                    ),
                                                    function (u) {
                                                      return _c("el-option", {
                                                        key: u.value,
                                                        attrs: {
                                                          label: u.label,
                                                          value: u.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "收费类型",
                                                  clearable: "",
                                                  disabled:
                                                    !_vm.canEditJudgment,
                                                },
                                                model: {
                                                  value:
                                                    _vm.batchKujialeForm
                                                      .chargeType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.batchKujialeForm,
                                                      "chargeType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batchKujialeForm.chargeType",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "免费",
                                                    value: "免费",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "收费",
                                                    value: "收费",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                style: {
                                                  color:
                                                    _vm.selectedCount(
                                                      "kujiale"
                                                    ) > 0
                                                      ? "#909399"
                                                      : "#E6A23C",
                                                  fontSize: "12px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "已选 " +
                                                    _vm._s(
                                                      _vm.selectedCount(
                                                        "kujiale"
                                                      )
                                                    ) +
                                                    " 条" +
                                                    _vm._s(
                                                      _vm.selectedCount(
                                                        "kujiale"
                                                      ) > 0
                                                        ? ""
                                                        : "（请先勾选要修改的物料）"
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.selectedCount("kujiale") > 0
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { size: "mini" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.clearMaterialSelection(
                                                          "kujiale"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("清空选择")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini",
                                                  loading:
                                                    _vm.batchKujialeLoading,
                                                  disabled:
                                                    _vm.isReadOnly ||
                                                    _vm.selectedCount(
                                                      "kujiale"
                                                    ) === 0,
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleBatchEditKujiale,
                                                },
                                              },
                                              [_vm._v("应用")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.groupByProductionOrder(
                                            _vm.kujialeMaterialList
                                          ),
                                          function (group, gIdx) {
                                            return _c(
                                              "div",
                                              {
                                                key: gIdx,
                                                staticStyle: {
                                                  "margin-bottom": "16px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "6px 10px",
                                                      background: "#f0f5ff",
                                                      "border-left":
                                                        "3px solid #409EFF",
                                                      "margin-bottom": "8px",
                                                      "font-size": "13px",
                                                      "font-weight": "bold",
                                                      color: "#303133",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  订单号：" +
                                                        _vm._s(
                                                          group.productionOrder
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-table",
                                                  {
                                                    ref:
                                                      "matTable_kujiale_" +
                                                      gIdx,
                                                    refInFor: true,
                                                    attrs: {
                                                      data: group.items,
                                                      size: "mini",
                                                      border: "",
                                                      "max-height": "400",
                                                      "row-key": _vm.rowKeyOf,
                                                    },
                                                    on: {
                                                      "selection-change":
                                                        function (rows) {
                                                          return _vm.handleMaterialSelectionChange(
                                                            "kujiale",
                                                            gIdx,
                                                            rows
                                                          )
                                                        },
                                                    },
                                                  },
                                                  [
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        type: "selection",
                                                        width: "45",
                                                        "reserve-selection": true,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        type: "index",
                                                        label: "序号",
                                                        width: "50",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "barCode",
                                                        label: "部件编码",
                                                        "min-width": "120",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "code",
                                                        label: "编码",
                                                        "min-width": "100",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "name",
                                                        label: "物料名称",
                                                        "min-width": "130",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "typeName",
                                                        label: "生产分类",
                                                        "min-width": "70",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "length",
                                                        label: "长",
                                                        width: "55",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "width",
                                                        label: "宽",
                                                        width: "55",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "height",
                                                        label: "高",
                                                        width: "55",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        prop: "quantity",
                                                        label: "数量",
                                                        width: "55",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: "问题类型",
                                                        width: "160",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                      placeholder:
                                                                        "-",
                                                                      disabled:
                                                                        !_vm.canEditJudgment,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleBomFieldChange(
                                                                            scope.row,
                                                                            "problemType"
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .problemType,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "problemType",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.problemType",
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm.dict
                                                                      .after_problem_type,
                                                                    function (
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key: item.value,
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                item.label,
                                                                              value:
                                                                                item.value,
                                                                            },
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: "责任部门",
                                                        width: "200",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm.isShowDutyPerson(
                                                                  scope.row
                                                                    .problemType
                                                                )
                                                                  ? _c(
                                                                      "treeselect",
                                                                      {
                                                                        staticClass:
                                                                          "duty-dept-select",
                                                                        attrs: {
                                                                          value:
                                                                            _vm.deptSelectValue(
                                                                              scope.row
                                                                            ),
                                                                          options:
                                                                            _vm.dutyDeptTree,
                                                                          clearable: true,
                                                                          disabled:
                                                                            !_vm.canEditJudgment,
                                                                          "append-to-body": true,
                                                                          "max-height": 450,
                                                                          "z-index": 3000,
                                                                          placeholder:
                                                                            "-",
                                                                        },
                                                                        on: {
                                                                          input:
                                                                            function (
                                                                              id
                                                                            ) {
                                                                              return _vm.handleRowDeptChange(
                                                                                scope.row,
                                                                                id
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: "责任人",
                                                        width: "140",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm.isShowDutyPerson(
                                                                  scope.row
                                                                    .problemType
                                                                )
                                                                  ? _c(
                                                                      "el-select",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100%",
                                                                          },
                                                                        attrs: {
                                                                          size: "mini",
                                                                          placeholder:
                                                                            "-",
                                                                          filterable:
                                                                            "",
                                                                          clearable:
                                                                            "",
                                                                          loading:
                                                                            !!_vm
                                                                              .dutyDeptUsersLoading[
                                                                              _vm.deptSelectValue(
                                                                                scope.row
                                                                              )
                                                                            ],
                                                                          disabled:
                                                                            !_vm.canEditJudgment,
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleRowDutyPersonChange(
                                                                                scope.row
                                                                              )
                                                                            },
                                                                          "visible-change":
                                                                            function (
                                                                              visible
                                                                            ) {
                                                                              return (
                                                                                visible &&
                                                                                _vm.loadDeptUsers(
                                                                                  _vm.deptSelectValue(
                                                                                    scope.row
                                                                                  )
                                                                                )
                                                                              )
                                                                            },
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            scope
                                                                              .row
                                                                              .dutyPerson,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                scope.row,
                                                                                "dutyPerson",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "scope.row.dutyPerson",
                                                                        },
                                                                      },
                                                                      _vm._l(
                                                                        _vm.deptUserOptions(
                                                                          _vm.deptSelectValue(
                                                                            scope.row
                                                                          )
                                                                        ),
                                                                        function (
                                                                          u
                                                                        ) {
                                                                          return _c(
                                                                            "el-option",
                                                                            {
                                                                              key: u.value,
                                                                              attrs:
                                                                                {
                                                                                  label:
                                                                                    u.label,
                                                                                  value:
                                                                                    u.value,
                                                                                },
                                                                            }
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: "终判部门",
                                                        width: "200",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm.isShowDutyPerson(
                                                                  scope.row
                                                                    .problemType
                                                                )
                                                                  ? _c(
                                                                      "treeselect",
                                                                      {
                                                                        staticClass:
                                                                          "duty-dept-select",
                                                                        attrs: {
                                                                          value:
                                                                            _vm.finalDeptSelectValue(
                                                                              scope.row
                                                                            ),
                                                                          options:
                                                                            _vm.dutyDeptTree,
                                                                          clearable: true,
                                                                          disabled:
                                                                            _vm.isReadOnly,
                                                                          "append-to-body": true,
                                                                          "max-height": 450,
                                                                          "z-index": 3000,
                                                                          placeholder:
                                                                            "-",
                                                                        },
                                                                        on: {
                                                                          input:
                                                                            function (
                                                                              id
                                                                            ) {
                                                                              return _vm.handleRowFinalDeptChange(
                                                                                scope.row,
                                                                                id
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: "终判责任人",
                                                        width: "140",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                _vm.isShowDutyPerson(
                                                                  scope.row
                                                                    .problemType
                                                                )
                                                                  ? _c(
                                                                      "el-select",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100%",
                                                                          },
                                                                        attrs: {
                                                                          size: "mini",
                                                                          placeholder:
                                                                            "-",
                                                                          filterable:
                                                                            "",
                                                                          clearable:
                                                                            "",
                                                                          loading:
                                                                            !!_vm
                                                                              .dutyDeptUsersLoading[
                                                                              _vm.finalDeptSelectValue(
                                                                                scope.row
                                                                              )
                                                                            ],
                                                                          disabled:
                                                                            _vm.isReadOnly,
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleRowFinalPersonChange(
                                                                                scope.row
                                                                              )
                                                                            },
                                                                          "visible-change":
                                                                            function (
                                                                              visible
                                                                            ) {
                                                                              return (
                                                                                visible &&
                                                                                _vm.loadDeptUsers(
                                                                                  _vm.finalDeptSelectValue(
                                                                                    scope.row
                                                                                  )
                                                                                )
                                                                              )
                                                                            },
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            scope
                                                                              .row
                                                                              .finalPerson,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                scope.row,
                                                                                "finalPerson",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "scope.row.finalPerson",
                                                                        },
                                                                      },
                                                                      _vm._l(
                                                                        _vm.deptUserOptions(
                                                                          _vm.finalDeptSelectValue(
                                                                            scope.row
                                                                          )
                                                                        ),
                                                                        function (
                                                                          u
                                                                        ) {
                                                                          return _c(
                                                                            "el-option",
                                                                            {
                                                                              key: u.value,
                                                                              attrs:
                                                                                {
                                                                                  label:
                                                                                    u.label,
                                                                                  value:
                                                                                    u.value,
                                                                                },
                                                                            }
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: "收费类型",
                                                        width: "100",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                      placeholder:
                                                                        "-",
                                                                      disabled:
                                                                        !_vm.canEditJudgment,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleBomFieldChange(
                                                                            scope.row,
                                                                            "chargeType"
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .chargeType,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "chargeType",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.chargeType",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-option",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "免费",
                                                                          value:
                                                                            "免费",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-option",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "收费",
                                                                          value:
                                                                            "收费",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "20px",
                                          "text-align": "center",
                                          color: "#909399",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "暂无酷家乐物料，请点击同步按钮获取"
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getAmendType !== "改单"
                      ? _c(
                          "el-tab-pane",
                          { attrs: { label: "原单物料", name: "original" } },
                          [
                            _vm.originalMaterialList.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                          padding: "8px",
                                          background: "#fafafa",
                                          "border-radius": "4px",
                                          display: "flex",
                                          "align-items": "center",
                                          gap: "10px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#606266" } },
                                          [_vm._v("批量修改：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "110px" },
                                            attrs: {
                                              size: "mini",
                                              placeholder: "问题类型",
                                              clearable: "",
                                              disabled: !_vm.canEditJudgment,
                                            },
                                            model: {
                                              value:
                                                _vm.batchOriginalForm
                                                  .problemType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.batchOriginalForm,
                                                  "problemType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "batchOriginalForm.problemType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.dict.after_problem_type,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOriginalForm.problemType
                                        )
                                          ? _c("treeselect", {
                                              staticClass: "duty-dept-select",
                                              staticStyle: { width: "200px" },
                                              attrs: {
                                                value: _vm.deptSelectValue(
                                                  _vm.batchOriginalForm
                                                ),
                                                options: _vm.dutyDeptTree,
                                                clearable: true,
                                                disabled: !_vm.canEditJudgment,
                                                "append-to-body": true,
                                                "max-height": 450,
                                                "z-index": 3000,
                                                placeholder: "责任部门",
                                              },
                                              on: {
                                                input: function (id) {
                                                  return _vm.setBatchDutyDept(
                                                    "batchOriginalForm",
                                                    id
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOriginalForm.problemType
                                        )
                                          ? _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "140px" },
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "责任人",
                                                  filterable: "",
                                                  clearable: "",
                                                  loading:
                                                    !!_vm.dutyDeptUsersLoading[
                                                      _vm.batchOriginalForm
                                                        .dutyDeptId
                                                    ],
                                                  disabled:
                                                    !_vm.canEditJudgment,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleBatchDutyPersonChange(
                                                      "batchOriginalForm"
                                                    )
                                                  },
                                                  "visible-change": function (
                                                    visible
                                                  ) {
                                                    return (
                                                      visible &&
                                                      _vm.loadDeptUsers(
                                                        _vm.batchOriginalForm
                                                          .dutyDeptId
                                                      )
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.batchOriginalForm
                                                      .dutyPerson,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.batchOriginalForm,
                                                      "dutyPerson",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batchOriginalForm.dutyPerson",
                                                },
                                              },
                                              _vm._l(
                                                _vm.deptUserOptions(
                                                  _vm.batchOriginalForm
                                                    .dutyDeptId
                                                ),
                                                function (u) {
                                                  return _c("el-option", {
                                                    key: u.value,
                                                    attrs: {
                                                      label: u.label,
                                                      value: u.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOriginalForm.problemType
                                        )
                                          ? _c("treeselect", {
                                              staticClass: "duty-dept-select",
                                              staticStyle: { width: "200px" },
                                              attrs: {
                                                value: _vm.finalDeptSelectValue(
                                                  _vm.batchOriginalForm
                                                ),
                                                options: _vm.dutyDeptTree,
                                                clearable: true,
                                                disabled: _vm.isReadOnly,
                                                "append-to-body": true,
                                                "max-height": 450,
                                                "z-index": 3000,
                                                placeholder: "终判部门",
                                              },
                                              on: {
                                                input: function (id) {
                                                  return _vm.setBatchFinalDept(
                                                    "batchOriginalForm",
                                                    id
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOriginalForm.problemType
                                        )
                                          ? _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "140px" },
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "终判责任人",
                                                  filterable: "",
                                                  clearable: "",
                                                  loading:
                                                    !!_vm.dutyDeptUsersLoading[
                                                      _vm.batchOriginalForm
                                                        .finalDeptId
                                                    ],
                                                  disabled: _vm.isReadOnly,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleBatchFinalPersonChange(
                                                      "batchOriginalForm"
                                                    )
                                                  },
                                                  "visible-change": function (
                                                    visible
                                                  ) {
                                                    return (
                                                      visible &&
                                                      _vm.loadDeptUsers(
                                                        _vm.batchOriginalForm
                                                          .finalDeptId
                                                      )
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.batchOriginalForm
                                                      .finalPerson,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.batchOriginalForm,
                                                      "finalPerson",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batchOriginalForm.finalPerson",
                                                },
                                              },
                                              _vm._l(
                                                _vm.deptUserOptions(
                                                  _vm.batchOriginalForm
                                                    .finalDeptId
                                                ),
                                                function (u) {
                                                  return _c("el-option", {
                                                    key: u.value,
                                                    attrs: {
                                                      label: u.label,
                                                      value: u.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              size: "mini",
                                              placeholder: "收费类型",
                                              clearable: "",
                                              disabled: !_vm.canEditJudgment,
                                            },
                                            model: {
                                              value:
                                                _vm.batchOriginalForm
                                                  .chargeType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.batchOriginalForm,
                                                  "chargeType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "batchOriginalForm.chargeType",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "免费",
                                                value: "免费",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                label: "收费",
                                                value: "收费",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              color:
                                                _vm.selectedCount("original") >
                                                0
                                                  ? "#909399"
                                                  : "#E6A23C",
                                              fontSize: "12px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "已选 " +
                                                _vm._s(
                                                  _vm.selectedCount("original")
                                                ) +
                                                " 条" +
                                                _vm._s(
                                                  _vm.selectedCount(
                                                    "original"
                                                  ) > 0
                                                    ? ""
                                                    : "（请先勾选要修改的物料）"
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.selectedCount("original") > 0
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { size: "mini" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.clearMaterialSelection(
                                                      "original"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("清空选择")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                              disabled:
                                                _vm.isReadOnly ||
                                                _vm.selectedCount(
                                                  "original"
                                                ) === 0,
                                            },
                                            on: {
                                              click:
                                                _vm.handleBatchEditOriginal,
                                            },
                                          },
                                          [_vm._v("应用")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.groupByProductionOrder(
                                        _vm.originalMaterialList
                                      ),
                                      function (group, gIdx) {
                                        return _c(
                                          "div",
                                          {
                                            key: gIdx,
                                            staticStyle: {
                                              "margin-bottom": "16px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "6px 10px",
                                                  background: "#f0f5ff",
                                                  "border-left":
                                                    "3px solid #409EFF",
                                                  "margin-bottom": "8px",
                                                  "font-size": "13px",
                                                  "font-weight": "bold",
                                                  color: "#303133",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  订单号：" +
                                                    _vm._s(
                                                      group.productionOrder
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-table",
                                              {
                                                ref:
                                                  "matTable_original_" + gIdx,
                                                refInFor: true,
                                                attrs: {
                                                  data: group.items,
                                                  size: "mini",
                                                  border: "",
                                                  "max-height": "400",
                                                  "row-key": _vm.rowKeyOf,
                                                },
                                                on: {
                                                  "selection-change": function (
                                                    rows
                                                  ) {
                                                    return _vm.handleMaterialSelectionChange(
                                                      "original",
                                                      gIdx,
                                                      rows
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    type: "selection",
                                                    width: "45",
                                                    "reserve-selection": true,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    type: "index",
                                                    label: "序号",
                                                    width: "50",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "barCode",
                                                    label: "部件编码",
                                                    "min-width": "120",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "code",
                                                    label: "编码",
                                                    "min-width": "100",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "name",
                                                    label: "物料名称",
                                                    "min-width": "130",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "typeName",
                                                    label: "生产分类",
                                                    "min-width": "70",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "length",
                                                    label: "长",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "width",
                                                    label: "宽",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "height",
                                                    label: "高",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "quantity",
                                                    label: "数量",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "问题类型",
                                                    width: "160",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  size: "mini",
                                                                  placeholder:
                                                                    "-",
                                                                  disabled:
                                                                    !_vm.canEditJudgment,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleBomFieldChange(
                                                                        scope.row,
                                                                        "problemType"
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .problemType,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "problemType",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.problemType",
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.dict
                                                                  .after_problem_type,
                                                                function (
                                                                  item
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: item.value,
                                                                      attrs: {
                                                                        label:
                                                                          item.label,
                                                                        value:
                                                                          item.value,
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "责任部门",
                                                    width: "200",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "treeselect",
                                                                  {
                                                                    staticClass:
                                                                      "duty-dept-select",
                                                                    attrs: {
                                                                      value:
                                                                        _vm.deptSelectValue(
                                                                          scope.row
                                                                        ),
                                                                      options:
                                                                        _vm.dutyDeptTree,
                                                                      clearable: true,
                                                                      disabled:
                                                                        !_vm.canEditJudgment,
                                                                      "append-to-body": true,
                                                                      "max-height": 450,
                                                                      "z-index": 3000,
                                                                      placeholder:
                                                                        "-",
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          id
                                                                        ) {
                                                                          return _vm.handleRowDeptChange(
                                                                            scope.row,
                                                                            id
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "责任人",
                                                    width: "140",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "el-select",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                      placeholder:
                                                                        "-",
                                                                      filterable:
                                                                        "",
                                                                      clearable:
                                                                        "",
                                                                      loading:
                                                                        !!_vm
                                                                          .dutyDeptUsersLoading[
                                                                          _vm.deptSelectValue(
                                                                            scope.row
                                                                          )
                                                                        ],
                                                                      disabled:
                                                                        !_vm.canEditJudgment,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleRowDutyPersonChange(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                      "visible-change":
                                                                        function (
                                                                          visible
                                                                        ) {
                                                                          return (
                                                                            visible &&
                                                                            _vm.loadDeptUsers(
                                                                              _vm.deptSelectValue(
                                                                                scope.row
                                                                              )
                                                                            )
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .dutyPerson,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "dutyPerson",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.dutyPerson",
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm.deptUserOptions(
                                                                      _vm.deptSelectValue(
                                                                        scope.row
                                                                      )
                                                                    ),
                                                                    function (
                                                                      u
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key: u.value,
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                u.label,
                                                                              value:
                                                                                u.value,
                                                                            },
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "终判部门",
                                                    width: "200",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "treeselect",
                                                                  {
                                                                    staticClass:
                                                                      "duty-dept-select",
                                                                    attrs: {
                                                                      value:
                                                                        _vm.finalDeptSelectValue(
                                                                          scope.row
                                                                        ),
                                                                      options:
                                                                        _vm.dutyDeptTree,
                                                                      clearable: true,
                                                                      disabled:
                                                                        _vm.isReadOnly,
                                                                      "append-to-body": true,
                                                                      "max-height": 450,
                                                                      "z-index": 3000,
                                                                      placeholder:
                                                                        "-",
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          id
                                                                        ) {
                                                                          return _vm.handleRowFinalDeptChange(
                                                                            scope.row,
                                                                            id
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "终判责任人",
                                                    width: "140",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "el-select",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                      placeholder:
                                                                        "-",
                                                                      filterable:
                                                                        "",
                                                                      clearable:
                                                                        "",
                                                                      loading:
                                                                        !!_vm
                                                                          .dutyDeptUsersLoading[
                                                                          _vm.finalDeptSelectValue(
                                                                            scope.row
                                                                          )
                                                                        ],
                                                                      disabled:
                                                                        _vm.isReadOnly,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleRowFinalPersonChange(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                      "visible-change":
                                                                        function (
                                                                          visible
                                                                        ) {
                                                                          return (
                                                                            visible &&
                                                                            _vm.loadDeptUsers(
                                                                              _vm.finalDeptSelectValue(
                                                                                scope.row
                                                                              )
                                                                            )
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .finalPerson,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "finalPerson",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.finalPerson",
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm.deptUserOptions(
                                                                      _vm.finalDeptSelectValue(
                                                                        scope.row
                                                                      )
                                                                    ),
                                                                    function (
                                                                      u
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key: u.value,
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                u.label,
                                                                              value:
                                                                                u.value,
                                                                            },
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "收费类型",
                                                    width: "100",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  size: "mini",
                                                                  placeholder:
                                                                    "-",
                                                                  disabled:
                                                                    !_vm.canEditJudgment,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleBomFieldChange(
                                                                        scope.row,
                                                                        "chargeType"
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .chargeType,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "chargeType",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.chargeType",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "免费",
                                                                      value:
                                                                        "免费",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "收费",
                                                                      value:
                                                                        "收费",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "20px",
                                      "text-align": "center",
                                      color: "#909399",
                                    },
                                  },
                                  [_vm._v("暂无原单物料")]
                                ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getAmendType !== "改单"
                      ? _c(
                          "el-tab-pane",
                          { attrs: { label: "其他物料", name: "other" } },
                          [
                            _vm.otherMaterialList.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                          padding: "8px",
                                          background: "#fafafa",
                                          "border-radius": "4px",
                                          display: "flex",
                                          "align-items": "center",
                                          gap: "10px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#606266" } },
                                          [_vm._v("批量修改：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "110px" },
                                            attrs: {
                                              size: "mini",
                                              placeholder: "问题类型",
                                              clearable: "",
                                              disabled: !_vm.canEditJudgment,
                                            },
                                            model: {
                                              value:
                                                _vm.batchOtherForm.problemType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.batchOtherForm,
                                                  "problemType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "batchOtherForm.problemType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.dict.after_problem_type,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOtherForm.problemType
                                        )
                                          ? _c("treeselect", {
                                              staticClass: "duty-dept-select",
                                              staticStyle: { width: "200px" },
                                              attrs: {
                                                value: _vm.deptSelectValue(
                                                  _vm.batchOtherForm
                                                ),
                                                options: _vm.dutyDeptTree,
                                                clearable: true,
                                                disabled: !_vm.canEditJudgment,
                                                "append-to-body": true,
                                                "max-height": 450,
                                                "z-index": 3000,
                                                placeholder: "责任部门",
                                              },
                                              on: {
                                                input: function (id) {
                                                  return _vm.setBatchDutyDept(
                                                    "batchOtherForm",
                                                    id
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOtherForm.problemType
                                        )
                                          ? _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "140px" },
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "责任人",
                                                  filterable: "",
                                                  clearable: "",
                                                  loading:
                                                    !!_vm.dutyDeptUsersLoading[
                                                      _vm.batchOtherForm
                                                        .dutyDeptId
                                                    ],
                                                  disabled:
                                                    !_vm.canEditJudgment,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleBatchDutyPersonChange(
                                                      "batchOtherForm"
                                                    )
                                                  },
                                                  "visible-change": function (
                                                    visible
                                                  ) {
                                                    return (
                                                      visible &&
                                                      _vm.loadDeptUsers(
                                                        _vm.batchOtherForm
                                                          .dutyDeptId
                                                      )
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.batchOtherForm
                                                      .dutyPerson,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.batchOtherForm,
                                                      "dutyPerson",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batchOtherForm.dutyPerson",
                                                },
                                              },
                                              _vm._l(
                                                _vm.deptUserOptions(
                                                  _vm.batchOtherForm.dutyDeptId
                                                ),
                                                function (u) {
                                                  return _c("el-option", {
                                                    key: u.value,
                                                    attrs: {
                                                      label: u.label,
                                                      value: u.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOtherForm.problemType
                                        )
                                          ? _c("treeselect", {
                                              staticClass: "duty-dept-select",
                                              staticStyle: { width: "200px" },
                                              attrs: {
                                                value: _vm.finalDeptSelectValue(
                                                  _vm.batchOtherForm
                                                ),
                                                options: _vm.dutyDeptTree,
                                                clearable: true,
                                                disabled: _vm.isReadOnly,
                                                "append-to-body": true,
                                                "max-height": 450,
                                                "z-index": 3000,
                                                placeholder: "终判部门",
                                              },
                                              on: {
                                                input: function (id) {
                                                  return _vm.setBatchFinalDept(
                                                    "batchOtherForm",
                                                    id
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isShowDutyPerson(
                                          _vm.batchOtherForm.problemType
                                        )
                                          ? _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "140px" },
                                                attrs: {
                                                  size: "mini",
                                                  placeholder: "终判责任人",
                                                  filterable: "",
                                                  clearable: "",
                                                  loading:
                                                    !!_vm.dutyDeptUsersLoading[
                                                      _vm.batchOtherForm
                                                        .finalDeptId
                                                    ],
                                                  disabled: _vm.isReadOnly,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleBatchFinalPersonChange(
                                                      "batchOtherForm"
                                                    )
                                                  },
                                                  "visible-change": function (
                                                    visible
                                                  ) {
                                                    return (
                                                      visible &&
                                                      _vm.loadDeptUsers(
                                                        _vm.batchOtherForm
                                                          .finalDeptId
                                                      )
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.batchOtherForm
                                                      .finalPerson,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.batchOtherForm,
                                                      "finalPerson",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batchOtherForm.finalPerson",
                                                },
                                              },
                                              _vm._l(
                                                _vm.deptUserOptions(
                                                  _vm.batchOtherForm.finalDeptId
                                                ),
                                                function (u) {
                                                  return _c("el-option", {
                                                    key: u.value,
                                                    attrs: {
                                                      label: u.label,
                                                      value: u.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              size: "mini",
                                              placeholder: "收费类型",
                                              clearable: "",
                                              disabled: !_vm.canEditJudgment,
                                            },
                                            model: {
                                              value:
                                                _vm.batchOtherForm.chargeType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.batchOtherForm,
                                                  "chargeType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "batchOtherForm.chargeType",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "免费",
                                                value: "免费",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                label: "收费",
                                                value: "收费",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              color:
                                                _vm.selectedCount("other") > 0
                                                  ? "#909399"
                                                  : "#E6A23C",
                                              fontSize: "12px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "已选 " +
                                                _vm._s(
                                                  _vm.selectedCount("other")
                                                ) +
                                                " 条" +
                                                _vm._s(
                                                  _vm.selectedCount("other") > 0
                                                    ? ""
                                                    : "（请先勾选要修改的物料）"
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.selectedCount("other") > 0
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { size: "mini" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.clearMaterialSelection(
                                                      "other"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("清空选择")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                              disabled:
                                                _vm.isReadOnly ||
                                                _vm.selectedCount("other") ===
                                                  0,
                                            },
                                            on: {
                                              click: _vm.handleBatchEditOther,
                                            },
                                          },
                                          [_vm._v("应用")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.groupByProductionOrder(
                                        _vm.otherMaterialList
                                      ),
                                      function (group, gIdx) {
                                        return _c(
                                          "div",
                                          {
                                            key: gIdx,
                                            staticStyle: {
                                              "margin-bottom": "16px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "6px 10px",
                                                  background: "#f0f5ff",
                                                  "border-left":
                                                    "3px solid #409EFF",
                                                  "margin-bottom": "8px",
                                                  "font-size": "13px",
                                                  "font-weight": "bold",
                                                  color: "#303133",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  订单号：" +
                                                    _vm._s(
                                                      group.productionOrder
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-table",
                                              {
                                                ref: "matTable_other_" + gIdx,
                                                refInFor: true,
                                                attrs: {
                                                  data: group.items,
                                                  size: "mini",
                                                  border: "",
                                                  "max-height": "400",
                                                  "row-key": _vm.rowKeyOf,
                                                },
                                                on: {
                                                  "selection-change": function (
                                                    rows
                                                  ) {
                                                    return _vm.handleMaterialSelectionChange(
                                                      "other",
                                                      gIdx,
                                                      rows
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    type: "selection",
                                                    width: "45",
                                                    "reserve-selection": true,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    type: "index",
                                                    label: "序号",
                                                    width: "50",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "code",
                                                    label: "编码",
                                                    "min-width": "130",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "name",
                                                    label: "物料名称",
                                                    "min-width": "140",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "length",
                                                    label: "长",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "width",
                                                    label: "宽",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "height",
                                                    label: "高",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "quantity",
                                                    label: "数量",
                                                    width: "55",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "问题类型",
                                                    width: "110",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  size: "mini",
                                                                  placeholder:
                                                                    "-",
                                                                  disabled:
                                                                    !_vm.canEditJudgment,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleBomFieldChange(
                                                                        scope.row,
                                                                        "problemType"
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .problemType,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "problemType",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.problemType",
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.dict
                                                                  .after_problem_type,
                                                                function (
                                                                  item
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: item.value,
                                                                      attrs: {
                                                                        label:
                                                                          item.label,
                                                                        value:
                                                                          item.value,
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "责任部门",
                                                    width: "200",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "treeselect",
                                                                  {
                                                                    staticClass:
                                                                      "duty-dept-select",
                                                                    attrs: {
                                                                      value:
                                                                        _vm.deptSelectValue(
                                                                          scope.row
                                                                        ),
                                                                      options:
                                                                        _vm.dutyDeptTree,
                                                                      clearable: true,
                                                                      disabled:
                                                                        !_vm.canEditJudgment,
                                                                      "append-to-body": true,
                                                                      "max-height": 450,
                                                                      "z-index": 3000,
                                                                      placeholder:
                                                                        "-",
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          id
                                                                        ) {
                                                                          return _vm.handleRowDeptChange(
                                                                            scope.row,
                                                                            id
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "责任人",
                                                    width: "140",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "el-select",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                      placeholder:
                                                                        "-",
                                                                      filterable:
                                                                        "",
                                                                      clearable:
                                                                        "",
                                                                      loading:
                                                                        !!_vm
                                                                          .dutyDeptUsersLoading[
                                                                          _vm.deptSelectValue(
                                                                            scope.row
                                                                          )
                                                                        ],
                                                                      disabled:
                                                                        !_vm.canEditJudgment,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleRowDutyPersonChange(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                      "visible-change":
                                                                        function (
                                                                          visible
                                                                        ) {
                                                                          return (
                                                                            visible &&
                                                                            _vm.loadDeptUsers(
                                                                              _vm.deptSelectValue(
                                                                                scope.row
                                                                              )
                                                                            )
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .dutyPerson,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "dutyPerson",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.dutyPerson",
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm.deptUserOptions(
                                                                      _vm.deptSelectValue(
                                                                        scope.row
                                                                      )
                                                                    ),
                                                                    function (
                                                                      u
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key: u.value,
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                u.label,
                                                                              value:
                                                                                u.value,
                                                                            },
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "终判部门",
                                                    width: "200",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "treeselect",
                                                                  {
                                                                    staticClass:
                                                                      "duty-dept-select",
                                                                    attrs: {
                                                                      value:
                                                                        _vm.finalDeptSelectValue(
                                                                          scope.row
                                                                        ),
                                                                      options:
                                                                        _vm.dutyDeptTree,
                                                                      clearable: true,
                                                                      disabled:
                                                                        _vm.isReadOnly,
                                                                      "append-to-body": true,
                                                                      "max-height": 450,
                                                                      "z-index": 3000,
                                                                      placeholder:
                                                                        "-",
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          id
                                                                        ) {
                                                                          return _vm.handleRowFinalDeptChange(
                                                                            scope.row,
                                                                            id
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "终判责任人",
                                                    width: "140",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm.isShowDutyPerson(
                                                              scope.row
                                                                .problemType
                                                            )
                                                              ? _c(
                                                                  "el-select",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                    attrs: {
                                                                      size: "mini",
                                                                      placeholder:
                                                                        "-",
                                                                      filterable:
                                                                        "",
                                                                      clearable:
                                                                        "",
                                                                      loading:
                                                                        !!_vm
                                                                          .dutyDeptUsersLoading[
                                                                          _vm.finalDeptSelectValue(
                                                                            scope.row
                                                                          )
                                                                        ],
                                                                      disabled:
                                                                        _vm.isReadOnly,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleRowFinalPersonChange(
                                                                            scope.row
                                                                          )
                                                                        },
                                                                      "visible-change":
                                                                        function (
                                                                          visible
                                                                        ) {
                                                                          return (
                                                                            visible &&
                                                                            _vm.loadDeptUsers(
                                                                              _vm.finalDeptSelectValue(
                                                                                scope.row
                                                                              )
                                                                            )
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .finalPerson,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            scope.row,
                                                                            "finalPerson",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "scope.row.finalPerson",
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm.deptUserOptions(
                                                                      _vm.finalDeptSelectValue(
                                                                        scope.row
                                                                      )
                                                                    ),
                                                                    function (
                                                                      u
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key: u.value,
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                u.label,
                                                                              value:
                                                                                u.value,
                                                                            },
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "收费类型",
                                                    width: "100",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  size: "mini",
                                                                  placeholder:
                                                                    "-",
                                                                  disabled:
                                                                    !_vm.canEditJudgment,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleBomFieldChange(
                                                                        scope.row,
                                                                        "chargeType"
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .chargeType,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "chargeType",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.chargeType",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "免费",
                                                                      value:
                                                                        "免费",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "收费",
                                                                      value:
                                                                        "收费",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "20px",
                                      "text-align": "center",
                                      color: "#909399",
                                    },
                                  },
                                  [_vm._v("暂无其他物料")]
                                ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.checkPer(["admin", "modifySupplement:pay"]) &&
            _vm.isDealerConfirm
              ? _c(
                  "div",
                  { staticClass: "detail-section" },
                  [
                    _c("div", { staticClass: "detail-section-title" }, [
                      _vm._v("确认付款"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { size: "small", "label-width": "90px" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款人" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.afterInfo.payNickName || "-")
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款时间" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.afterInfo.payTime || "-")
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款金额" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          gap: "8px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              flex: 1,
                                              color:
                                                _vm.afterInfo.chargeAmount ==
                                                null
                                                  ? "#C0C4CC"
                                                  : "#303133",
                                              fontWeight:
                                                _vm.afterInfo.chargeAmount ==
                                                null
                                                  ? "normal"
                                                  : "bold",
                                              fontSize: "14px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.afterInfo.chargeAmount ==
                                                    null
                                                    ? "请确认报价"
                                                    : "¥" +
                                                        Number(
                                                          _vm.afterInfo
                                                            .chargeAmount
                                                        ).toFixed(2)
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.isReadOnly
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                  icon: "el-icon-view",
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleOpenQuoteDialog,
                                                },
                                              },
                                              [_vm._v("查看报价")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            Number(_vm.afterInfo.chargeAmount) !== 0
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "付款凭证" } },
                                      [
                                        _vm.isReadOnly || !_vm.canEditPay
                                          ? _c("span", [
                                              _vm.parseFiles(
                                                _vm.afterInfo.paymentProof
                                              ).length > 0
                                                ? _c(
                                                    "span",
                                                    _vm._l(
                                                      _vm.parseFiles(
                                                        _vm.afterInfo
                                                          .paymentProof
                                                      ),
                                                      function (item, idx) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key: idx,
                                                            staticStyle: {
                                                              display:
                                                                "inline-block",
                                                              "margin-right":
                                                                "8px",
                                                              "margin-bottom":
                                                                "8px",
                                                            },
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              staticStyle: {
                                                                width: "80px",
                                                                height: "80px",
                                                                "border-radius":
                                                                  "4px",
                                                              },
                                                              attrs: {
                                                                src:
                                                                  item.url ||
                                                                  _vm.$store
                                                                    .getters
                                                                    .imgPreviewPrefix +
                                                                    item.realName,
                                                                fit: "cover",
                                                                "preview-src-list":
                                                                  _vm.getPreviewList(
                                                                    _vm
                                                                      .afterInfo
                                                                      .paymentProof
                                                                  ),
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#909399",
                                                      },
                                                    },
                                                    [_vm._v("暂无凭证")]
                                                  ),
                                            ])
                                          : _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  gap: "8px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-upload",
                                                  {
                                                    attrs: {
                                                      action:
                                                        _vm.filesUploadApi +
                                                        "?name=test",
                                                      headers: _vm.headers,
                                                      "on-success": function (
                                                        res,
                                                        file,
                                                        fileList
                                                      ) {
                                                        return _vm.handleUploadSuccess(
                                                          "paymentProof",
                                                          res,
                                                          file,
                                                          fileList
                                                        )
                                                      },
                                                      "on-remove": function (
                                                        file
                                                      ) {
                                                        return _vm.handleUploadRemove(
                                                          "paymentProof",
                                                          file
                                                        )
                                                      },
                                                      "before-upload":
                                                        _vm.handleBeforeUpload,
                                                      accept: "image/*",
                                                      multiple: "",
                                                      "file-list":
                                                        _vm.paymentProofUploadList,
                                                      disabled: !_vm.canEditPay,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: "primary",
                                                          disabled:
                                                            !_vm.canEditPay,
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-upload",
                                                        }),
                                                        _vm._v(" 上传付款凭证"),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      type: "warning",
                                                      icon: "el-icon-view",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.handleViewPayQr,
                                                    },
                                                  },
                                                  [_vm._v("查看付款二维码")]
                                                ),
                                              ],
                                              1
                                            ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款备注" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "请输入付款备注",
                                        rows: "3",
                                        maxlength: "200",
                                        "show-word-limit": "",
                                        disabled: !_vm.canEditPay,
                                      },
                                      model: {
                                        value: _vm.afterInfo.payRemark,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.afterInfo,
                                            "payRemark",
                                            $$v
                                          )
                                        },
                                        expression: "afterInfo.payRemark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.checkPer(["admin", "modifySupplement:receive"]) &&
            _vm.afterInfo.payTime
              ? _c(
                  "div",
                  { staticClass: "detail-section" },
                  [
                    _c("div", { staticClass: "detail-section-title" }, [
                      _vm._v("确认收款"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { size: "small", "label-width": "90px" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "收款人" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.afterInfo.receiveNickName || "-"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "收款时间" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.afterInfo.receiveTime || "-")
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "收款金额" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        min: 0,
                                        precision: 2,
                                        controls: false,
                                        placeholder: "请输入收款金额",
                                        disabled: !!_vm.afterInfo.receiveTime,
                                      },
                                      model: {
                                        value: _vm.afterInfo.receiveAmount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.afterInfo,
                                            "receiveAmount",
                                            $$v
                                          )
                                        },
                                        expression: "afterInfo.receiveAmount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "20px",
                  "margin-bottom": "40px",
                  "text-align": "center",
                },
              },
              [
                _c("el-button", { on: { click: _vm.goBack } }, [
                  _vm._v(_vm._s(_vm.isReadOnly ? "返回" : "取消")),
                ]),
                _vm._v(" "),
                !_vm.submitted && !_vm.isReadOnly && !_vm.isDealerConfirm
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "success", loading: _vm.saveLoading },
                        on: {
                          click: function ($event) {
                            return _vm.handleSave("暂存")
                          },
                        },
                      },
                      [_vm._v("暂存")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.submitted && !_vm.isReadOnly && !_vm.isDealerConfirm
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.saveLoading },
                        on: {
                          click: function ($event) {
                            return _vm.handleSave("已提交")
                          },
                        },
                      },
                      [_vm._v("提交")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isDealerConfirm &&
                !_vm.isReadOnly &&
                Number(_vm.afterInfo.chargeAmount) !== 0 &&
                !_vm.afterInfo.payTime
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          icon: "el-icon-money",
                          loading: _vm.saveLoading,
                        },
                        on: { click: _vm.handleConfirmPay },
                      },
                      [_vm._v("确认付款")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isReadOnly &&
                _vm.afterInfo.payTime &&
                !_vm.afterInfo.receiveTime
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          icon: "el-icon-money",
                          loading: _vm.saveLoading,
                        },
                        on: { click: _vm.handleConfirmReceive },
                      },
                      [_vm._v("确认收款")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.submitted && !_vm.isReadOnly
                  ? _c(
                      "span",
                      {
                        staticStyle: { color: "#909399", "font-size": "13px" },
                      },
                      [_vm._v("已提交；判责与物料仍可编辑，改完点“保存信息”")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "付款二维码",
            visible: _vm.showPayQrDialog,
            width: "420px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPayQrDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "10px" } },
            [
              _c("el-image", {
                staticStyle: { width: "320px", height: "320px" },
                attrs: {
                  src: _vm.payQrUrl,
                  fit: "contain",
                  "preview-src-list": [_vm.payQrUrl],
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价信息",
            visible: _vm.showQuoteDialog,
            width: "70%",
            top: "10vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showQuoteDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.quoteLoading,
                  expression: "quoteLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.quoteList,
                    border: "",
                    size: "small",
                    "max-height": "420",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "productionOrder",
                      label: "订单号",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditName",
                      label: "产品名称",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productionStatus",
                      label: "订单状态",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "报价小计", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#E6A23C",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm
                                        .getQuoteTotal(scope.row.quotes)
                                        .toFixed(2)
                                    )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    padding: "12px 4px 0",
                    "font-size": "14px",
                  },
                },
                [
                  _vm._v("\n        报价合计："),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#E6A23C",
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                    },
                    [_vm._v("¥" + _vm._s(_vm.quoteTotal.toFixed(2)))]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showQuoteDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _vm.canEditPay && Number(_vm.afterInfo.chargeAmount) !== 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleUseQuoteAmount },
                    },
                    [
                      _vm._v(
                        "确认报价（¥" + _vm._s(_vm.quoteTotal.toFixed(2)) + "）"
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }